<template lang="pug">
.resumo-table(v-if='etapas')
    grid-table-component(:headers='headersResumo', :data='etapas', :is-paginated='false')

        template(v-slot:status='{ item }')
            .situacao
                chip-component(
                    border-color='transparent',
                    :background-color='getBackgroundColor(item.status)',
                    :color='getColor(item.status)',
                    :label='getLabel(item.status)',
                    border-radius='5px',
                    width='150px'
                )

                //- button-component(
                //-     v-if='!isGerenteOperacional'
                //-     icon='mdi-pencil-outline',
                //-     @click.native='toEtapa(item)',
                //-     color='#006fb9',
                //-     label='Editar',
                //-     background-color='transparent',
                //- )

</template>

<script>
import { Perfil } from '@/utils/constants.utils.js';
import { CondicaoEnum } from '@/enums/processo.enum';

export default {

    name: 'ResumoAnaliseTable',

    components: {

    },

    props: {
        etapas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {

            headersResumo: [
                { text: 'Etapa', field: 'nome' },
                { text: 'Situação', field: 'status' },
            ],
        };
    },

    methods: {
        toEtapa(item) {
            this.$emit('tb:toEtapa', item);
        },
        getBackgroundColor(status) {
            const colors = {
                true: '#41B73999',
                APROVADO: '#41B73999',
                false: '#A7363199',
                REPROVADO: '#A7363199',
                DISPENSADO: '#2964AD99',
                ANDAMENTO: '#89929D99'
            };
            return colors[status] || '#FFF';
        },
        getLabel(status) {
            if (status === 'ANDAMENTO') {
                return 'Em andamento';
            } else if (status === 'DISPENSADO') {
                return 'Dispensado';
            } else {
                return status ? 'Aprovado' : 'Reprovado';
            }
        },
        getColor(status) {
            return status === 'ANDAMENTO' ? 'var(--primary-black)': 'var(--primary-white)';
        }
    },

    computed: {
        validarOuVisualizarAnalise() {
            return this.$eu().perfil === Perfil.GERENTE_OPERACIONAL ||
                this.$route.params.condicao === CondicaoEnum.AGUARDANDO_VALIDACAO_ANALISE.id;
        }
    },

};
</script>

<style lang="scss" scoped>
.situacao {
    display: flex;
}
</style>
